import { AnimatePresence, motion } from "framer-motion";
import EntityImageThumbnail from "./EntityImageThumbnail";

const SM_SIZE = 40;
const GAP = 8;
const TRANSITION = { duration: 0.25, ease: [0.4, 0, 0.2, 1] };

interface EntityImageRowThumbnailProps {
  visible: boolean;
  imageUrl?: string | null;
  imageFailed: boolean;
  onImageError: () => void;
  isGenerating: boolean;
  readOnly: boolean;
  onClick?: () => void;
  ariaLabel: string;
  tooltipText: string;
  tooltipDisabled: boolean;
  /** The parent's flex gap in px; cancelled while hidden so a zero-width thumbnail leaves no gap. */
  containerGap?: number;
}

export default function EntityImageRowThumbnail({
  visible,
  imageUrl,
  imageFailed,
  onImageError,
  isGenerating,
  readOnly,
  onClick,
  ariaLabel,
  tooltipText,
  tooltipDisabled,
  containerGap = 0,
}: EntityImageRowThumbnailProps) {
  return (
    <div style={{ position: "relative", flexShrink: 0 }}>
      <motion.div
        aria-hidden="true"
        initial={false}
        animate={{ width: visible ? SM_SIZE : 0, marginRight: visible ? GAP - containerGap : -containerGap }}
        transition={TRANSITION}
        style={{ height: SM_SIZE }}
      />
      <AnimatePresence>
        {visible && (
          <motion.div
            key="portrait-thumbnail"
            initial={{ opacity: 0, x: -16 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -16 }}
            transition={TRANSITION}
            style={{ position: "absolute", top: 0, left: 0 }}
          >
            <EntityImageThumbnail
              size="sm"
              imageUrl={imageUrl}
              imageFailed={imageFailed}
              onImageError={onImageError}
              isGenerating={isGenerating}
              readOnly={readOnly}
              onClick={onClick}
              ariaLabel={ariaLabel}
              tooltipText={tooltipText}
              tooltipDisabled={tooltipDisabled}
            />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
